import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, logOut } from "../firebase";
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  return (
    <>
      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <button
            className="close-button"
            onClick={toggleSidebar}
            aria-label="Close navigation menu"
          >
            ×
          </button>
        </div>

        <nav className="sidebar-nav">
          <div onClick={() => { navigate("/"); toggleSidebar(); }}>Explore</div>
          <div onClick={() => { navigate("/dashboard"); toggleSidebar(); }}>
            Performance Dashboard <span role="img" aria-label="dashboard">🔬</span>
          </div>
          <div onClick={() => { navigate("/logs"); toggleSidebar(); }}>Logs</div>
          <div onClick={() => { navigate("/sota-tracking"); toggleSidebar(); }}>
            SOTA Tracking
          </div>
          <div onClick={() => { navigate("/stack-observatory"); toggleSidebar(); }}>
            Stack Observatory <span role="img" aria-label="telescope">🔭</span>
          </div>
          <div onClick={() => { window.open("https://report.fairpatterns.com/", "_blank"); toggleSidebar(); }}>Reports</div>
          {/* <div onClick={() => { navigate("/database"); toggleSidebar(); }}>Database</div> */}
          <div onClick={() => { navigate("/org-management"); toggleSidebar(); }}>
            Org Management <span role="img" aria-label="orgs"></span>
          </div>
          <div onClick={() => { navigate("/review-tool-management"); toggleSidebar(); }}>
            Review Tool Access Management <span role="img" aria-label="tools"></span>
          </div>
          <div onClick={() => { navigate("/report-tool-management"); toggleSidebar(); }}>
            Report Tool Access Management <span role="img" aria-label="tools"></span>
          </div>
          <div onClick={() => { navigate("/observatory-access-management"); toggleSidebar(); }}>
            Observatory Access Management <span role="img" aria-label="observatory"></span>
          </div>
          <div onClick={() => { navigate("/evidence-trail-management"); toggleSidebar(); }}>
            Evidence Trail Access Management <span role="img" aria-label="tools"></span>
          </div>
          <div onClick={() => { navigate("/task-tracking"); toggleSidebar(); }}>
            Task Tracking <span role="img" aria-label="tasks"></span>
          </div>
          {/* <div onClick={() => { navigate("/updates"); toggleSidebar(); }}>
            Updates <span className="update-star">★</span>
          </div> */}
          {/* <div onClick={() => { navigate("/version2"); toggleSidebar(); }}>Version 2</div> */}
          <div onClick={() => { window.open("https://deceptive-design-agent.vercel.app/", "_blank"); toggleSidebar(); }}>
            Chat <span role="img" aria-label="chat">💬</span>
          </div>
          <div onClick={() => { window.open("https://product-price-tracker-nine.vercel.app/", "_blank"); toggleSidebar(); }}>
            Product Price Tracker <span role="img" aria-label="tracker"></span>
          </div>
          <div onClick={() => { navigate("/tech-roadmap"); toggleSidebar(); }}>
            Tech Roadmap <span role="img" aria-label="roadmap">🗺️</span>
          </div>
          <div onClick={() => { navigate("/documentation/about"); toggleSidebar(); }}>Documentation</div>
          <div onClick={() => { navigate("/documentation-v2"); toggleSidebar(); }}>
            Documentation (V2)
          </div>
          <div onClick={() => { navigate("/report-documentation"); toggleSidebar(); }}>Tool Documentation</div>
          <div onClick={() => { navigate("/customer-due-diligence"); toggleSidebar(); }}>Customer Due Diligence</div>
          {/* <div onClick={() => { navigate("/settings"); toggleSidebar(); }}>Settings</div> */}
          <div onClick={() => { navigate("/tiktok-analysis"); toggleSidebar(); }}>TikTok Analysis <span role="img" aria-label="tiktok">📱</span></div>
          <div onClick={() => { navigate("/help"); toggleSidebar(); }}>Help</div>
          {user ? (
            <>
              <div className="user-info">{user.displayName}</div>
              <div onClick={() => { logOut(); toggleSidebar(); }}>Logout</div>
            </>
          ) : (
            <div onClick={() => { navigate("/login"); toggleSidebar(); }}>Login</div>
          )}
        </nav>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={toggleSidebar}
        />
      )}
    </>
  );
};

export default Sidebar;
